import { jsxs as H, jsx as t } from "react/jsx-runtime";
function l({ className: e = "", height: r = 20, width: i = 20 }) {
  return /* @__PURE__ */ H(
    "svg",
    {
      className: e,
      fill: "none",
      height: r,
      viewBox: "0 0 24 24",
      width: i,
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "11.5385", stroke: "white", strokeWidth: "0.923077" }),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M4.00941 14.319L4.00415 9.65807H4.86162L4.86688 14.319H4.00941ZM2.09981 12.4251V11.5677L6.7607 11.5624V12.4199L2.09981 12.4251ZM7.73342 15.8182V8.2114H12.6468L12.6416 9.18988H8.86445V11.4993H12.2365V12.462H8.85919V14.824L12.7363 14.8292V15.8182H7.73342ZM15.6657 15.8182L12.9775 8.2114H14.077L16.3285 14.5294L18.5748 8.2114H19.6795L16.9913 15.8182H15.6657Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
export {
  l as default
};
